export const settingsStore = {
    state: () => ({
        client: {
            chartType: 0,
            cameraApiAddress: 'localhost',
            cameraAddressScheme: 0,
            cameraApiAddressPort: 5000,
            autoEndVotingAfterAllVoted: false,
            autoGoToNextVotingAfterSave: false,
            autoStartNextVoting: false,
            autoStartNextVotingTime: 3,
            rememberVotingMode: false,
            rememberVotingModeValue: 1,
            adminVoteForUser: true,
            menuInteractiveShowQorum: true,
            interactiveModalVotingShowAvatar: true,
            interactiveModalQuorumShowAvatar: true,
            interactiveDiscussionShowAvatar: true,
            clientLogoShowOw: true,
            clientLogoShowDocuments: true,
            clientFooterShowDocuments: true,
            showClockInOw: true,
            userOnlineBasedOnMicrophones: false,
            supportCalendarIntegration: false,
            displayGovernmentNews: true,
            showUserAvatarInMultiSelect: false,
            showUserAvatarInContacts: true,
            showVotingListInOw: false,
            hideDefaultFooterInEmail: false,
            dontShowWhiteBackgroundInESesjaTvOverlay: false,
            supportDiscussionProfile: true,
            supportDisucssionAV: true,
            supportDiscussionWF: true,
            attachmentViewerCurrentScale: 100,
            attachmentViewerSaveScale: false,
            attachmentViewerIsShowOnOW: true,
        },
        user: {
            chartType: 0,
            cameraApiAddress: 'localhost',
            cameraAddressScheme: 0,
            cameraApiAddressPort: 5000,
            autoEndVotingAfterAllVoted: false,
            autoGoToNextVotingAfterSave: false,
            autoStartNextVoting: false,
            autoStartNextVotingTime: 3,
            rememberVotingMode: false,
            rememberVotingModeValue: 1,
            adminVoteForUser: true,
            menuInteractiveShowQorum: true,
            interactiveModalVotingShowAvatar: true,
            interactiveModalQuorumShowAvatar: true,
            interactiveDiscussionShowAvatar: true,
            clientLogoShowOw: true,
            clientLogoShowDocuments: true,
            clientFooterShowDocuments: true,
            showClockInOw: true,
            userOnlineBasedOnMicrophones: false,
            supportCalendarIntegration: false,
            displayGovernmentNews: true,
            showUserAvatarInMultiSelect: false,
            showUserAvatarInContacts: true,
            showVotingListInOw: false,
            hideDefaultFooterInEmail: false,
            dontShowWhiteBackgroundInESesjaTvOverlay: false,
            attachmentViewerIsShowOnOW: true,
        },
        runtime: {
            chartType: 0,
            cameraApiAddress: 'localhost',
            cameraAddressScheme: 0,
            cameraApiAddressPort: 5000,
            autoEndVotingAfterAllVoted: false,
            autoGoToNextVotingAfterSave: false,
            autoStartNextVoting: false,
            autoStartNextVotingTime: 3,
            rememberVotingMode: false,
            rememberVotingModeValue: 1,
            adminVoteForUser: true,
            menuInteractiveShowQorum: true,
            interactiveModalVotingShowAvatar: true,
            interactiveModalQuorumShowAvatar: true,
            interactiveDiscussionShowAvatar: true,
            clientLogoShowOw: true,
            clientLogoShowDocuments: true,
            clientFooterShowDocuments: true,
            showClockInOw: true,
            userOnlineBasedOnMicrophones: false,
            supportCalendarIntegration: false,
            displayGovernmentNews: true,
            showUserAvatarInMultiSelect: false,
            showUserAvatarInContacts: true,
            showVotingListInOw: false,
            hideDefaultFooterInEmail: false,
            dontShowWhiteBackgroundInESesjaTvOverlay: false,
            supportDiscussionProfile: true,
            supportDisucssionAV: true,
            supportDiscussionWF: true,
            attachmentViewerCurrentScale: 100,
            attachmentViewerSaveScale: false,
            attachmentViewerIsShowOnOW: true,
        },
        allowIpAddress: '',
        logoBase64: '',
        cadenceYears: '-',
        cadenceNumber: null,
        clientTypeConfiguration: {
            showInformationForClientType: false,
            showWelcomeInNewCadence: false,
            showesesjaTvConfigurationInfo: false,
            showAdvertisingBanner: false,
            esesjaTvKod: '',
        },
    }),
    mutations: {
        setClientSettings(state, status) {
            state.client = status;
        },

        setUserSettings(state, status){
            state.user = status;
        },

        setRuntimeSettings(state, status){
            state.runtime = status;
        },

        setAttachmentViewerCurrentScale(state, scale) {
            state.runtime.attachmentViewerCurrentScale = scale;
        },

        setAttachmentViewerSaveScale(state, saveScale) {
            state.runtime.attachmentViewerSaveScale = saveScale;
        },

        setVotingsChartType(state, status) {
            state.client.chartType = status;
            state.runtime.chartType = status;
        },

        seCameraApiAddress(state, status) {
            state.client.cameraApiAddress = status;
        },

        setAllowIpAddress(state, ipAddress){
            state.allowIpAddress = ipAddress
        },

        setLogoBase64(state, status) {
            state.logoBase64 = status;
        },

        setCadenceYears(state, status) {
            state.cadenceYears = status;
        },

        setCadenceNumber(state, status) {
            state.cadenceNumber = status;
        },

        setClientTypeConfiguration(state, configuration) {
            const type = parseInt(configuration.type);
            const isSupportedClientType = type > 0 && type < 7;
            const isNewCadence = configuration.cadenceYears == '2024-2029';
            const hasEsesjaTvKod = configuration.esesjaTvKod != null && configuration.esesjaTvKod.length > 0;

            state.clientTypeConfiguration = {
                showInformationForClientType: isSupportedClientType && !isNewCadence,
                showWelcomeInNewCadence: isSupportedClientType && isNewCadence,
                showesesjaTvConfigurationInfo: isSupportedClientType && isNewCadence && hasEsesjaTvKod,
                showAdvertisingBanner: isSupportedClientType,
                esesjaTvKod: hasEsesjaTvKod ? configuration.esesjaTvKod : '',
            };
            state.cadenceYears = configuration.cadenceYears;
            state.cadenceNumber = configuration.cadenceNumber;
        },
    }
}
